import { Dictionary, provideStoreFeature, Store } from '@softline/core';
import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';

import * as TranslationStore from './translation.store';
import { TranslationServiceStoreAdapter } from './translation-service-store.adapter';
import { SOFTLINE_DATA_TRANSLATIONS, SOFTLINE_FEATURE_TRANSLATION, Translations } from './i18n.shared';
import { map } from 'rxjs/operators';

export interface TranslationMap {
  module: string,
  translations: Dictionary<object>
}

export const provideTranslation: (module: Translations) => Array<Provider | EnvironmentProviders> = (module: Translations) => {
  return [
    {provide: SOFTLINE_DATA_TRANSLATIONS, useValue: module, multi: true}
  ]
}

export const provideTranslations: (translationMap: TranslationMap) => Array<Provider | EnvironmentProviders> = (translationMap: TranslationMap) => {
  const returnValue: Array<Provider | EnvironmentProviders> = [];
  for(const [key, value] of Object.entries(translationMap.translations)) {
    if(!value)
      continue;
    const translation: Translations = {
      module: translationMap.module,
      language: key,
      translations: value,
    }
    returnValue.push({provide: SOFTLINE_DATA_TRANSLATIONS, useValue: translation, multi: true});
  }
  return returnValue;
}


export const provideI18N: () => Array<Provider | EnvironmentProviders> = () => {
  return [
    provideStoreFeature({
      name: SOFTLINE_FEATURE_TRANSLATION,
      feature: TranslationStore.feature,
    }),
    //TODO: remove if TranslationStore is removed
    provideEnvironmentInitializer(() => {
      inject(TranslationServiceStoreAdapter);
    })
  ]
}
